import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddOnCardLayoutUI = ({
  'data-test-id': dataTestId,
  'data-selenium-id': dataSeleniumId,
  title,
  pricing,
  subtitle,
  description,
  cta,
  alert
}) => {
  return /*#__PURE__*/_jsx(CardWrapper, {
    "data-test-id": dataTestId,
    "data-selenium-id": dataSeleniumId,
    marginBlockEnd: "400",
    padding: "1000",
    borderStyle: "solid",
    borderColor: "border-tertiary-default",
    borderWidth: "100",
    borderRadius: "300",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: '900',
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(CardSection, {
        padding: "0",
        children: [alert, /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(CardHeader, {
              title: title,
              titleSize: "small",
              padding: "0"
            }), /*#__PURE__*/_jsx(Text, {
              as: "div",
              typography: "heading-50",
              marginBlockStart: "300",
              children: /*#__PURE__*/_jsxs(Flex, {
                flexDirection: "row",
                justifyContent: "space-between",
                gap: "100",
                children: [pricing, subtitle]
              })
            })]
          }), /*#__PURE__*/_jsx(View, {
            blockSize: "1000",
            paddingBlockStart: "100",
            children: cta
          })]
        })]
      }), /*#__PURE__*/_jsx(CardSection, {
        padding: "0",
        children: /*#__PURE__*/_jsx(Small, {
          children: description
        })
      })]
    })
  });
};
export default AddOnCardLayoutUI;